<template>
  <div id="copyright" class="col-lg-12 col-lg-12 col-sm-5 col-xs-5">
  <p>Copyright &copy; Bezzina {{ current_year }}</p>
  </div> 
</template>

<script>
export default {
  name: 'copyright',
  data () {
    return {
      current_year: ''
    }
  },
  methods: {
    getCurrentYear () {
      const currentDate = new Date()
      this.current_year = currentDate.getFullYear()
    }
  },
  created () {
    this.getCurrentYear()
  }
}
</script>

<style scoped>
#copyright {
  display: inline-block;
  vertical-align: baseline;
  /*margin-top: 100px;*/
  /*padding-top: 20px;*/
}
p {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/CopyrightComponent.vue